import React from 'react';
import {Loader} from "components";
import {Svg} from "assets";

export const BulkActionToolbar = ({
                                      selectedCount,
                                      handleSelectAll,
                                      handleAccept,
                                      handleReject,
                                      handleClose,
                                      loadingAccept,
                                      loadingReject
                                  }) => {
    return (
        <div className='bulk-action-toolbar-wrapper'>
            <div className='bulk-action-toolbar-selected-info'>
                <div className="bulk-action-toolbar-selected-count">
                    {selectedCount}
                </div>

                <p className='bulk-action-toolbar-selected-text'>
                    Selected
                </p>
            </div>

            <button
                className='bulk-action-toolbar-select-all-btn'
                onClick={(e) => handleSelectAll(e, true)}
            >
                <div className='bulk-action-toolbar-select-all-svg'>
                    <Svg.SelectionSvg/>
                </div>
                select All
            </button>

            <button
                className='bulk-action-toolbar-accept-btn'
                onClick={handleAccept}
                disabled={!!loadingAccept?.length}
            >
                {loadingAccept?.length ?
                    <Loader styles={{
                        color: 'white',
                        minWidth: 15,
                        maxWidth: 15,
                        minHeight: 15,
                        maxHeight: 15
                    }}/> : 'Accept'}
            </button>

            <button
                className='bulk-action-toolbar-reject-btn'
                onClick={handleReject}
                disabled={!!loadingReject?.length}
            >
                {loadingReject?.length ? <Loader styles={{
                    color: 'white',
                    minWidth: 15,
                    maxWidth: 15,
                    minHeight: 15,
                    maxHeight: 15
                }}/> : 'Reject'}
            </button>

            <button
                className='bulk-action-toolbar-close-btn'
                onClick={handleClose}
            >
                <Svg.CloseSvg/>
            </button>
        </div>
    );
};

